// extracted by mini-css-extract-plugin
module.exports = {"errorPage":"styles_errorPage__2VEN3","title":"styles_title__3-WEK","description":"styles_description__Z9VgY"};